import { Breadcrumbs, RBButton, RbContextMenu } from '@scmlatam/web-ui';
import { Table } from '../components/Table';
import { useTranslation } from 'react-i18next';
import { Box, Icon } from '@mui/material';
import { useTable } from '../hooks/useTable';
//import { EditDialog } from "../components/EditDialog";
//import { DeactivateDialog } from "../components/DeactivateDialog";
//import { AssignContractDialog } from "../components/AssignContractDialog";
//import { AssignPositionDialog } from "../components/AssignPositionDialog";
//import { AssignTagDialog } from "../components/AssignTagDialog";
import { EmptyState } from '@scmlatam/web-ui';
import { useFormUpdateEmployee } from '../hooks/useFormUpdateEmployee';
import { UpdateEmployeeDialog } from '../components/UpdateEmployeeDialog';
import { useFormAddEmployee } from '../hooks/useFormAddEmployee';
import { AddEmployeeDialog } from '../components/AddEmployeeDialog';
import { useFormAddTag } from '../hooks/useFormAddTag';
import { AddTag } from '../components/AssignTagDialog';
import { useFormAssignAccrualProfile } from '../hooks/useFormAssignAccrualProfile';
import { AssignAccrualProfileDialog } from '../components/AssignAccrualProfileDialog';
import { useFormAssignScheduleRule } from '../hooks/useFormAssignScheduleRule';
import { AssignScheduleRule } from '../components/AssignScheduleRuleDialog';
import { useFormAssignPayRule } from '../hooks/useFormAssignPayRule';
import { AssignPayRuleDialog } from '../components/AssignPayRuleDialog';
import { useFormAssignHiring } from '../hooks/useFormAssignHiring';
import { AssignHiringDialog } from '../components/AssignHiringDialog';
import { useFormAssignPosition } from '../hooks/useFormAssignPosition.ts';
import { AssignPositionDialog } from '../components/AssignPositionDialog.tsx';

const SubPage = () => {
    const { t } = useTranslation('workers.table');

    const tableProps = useTable();

    const formAddProps = useFormAddEmployee({
        rows: tableProps.rows,
        reload: tableProps.reload,
    });

    const formUpdateProps = useFormUpdateEmployee({
        rowsSelected: tableProps.rows.filter((row) => tableProps.selectedRowIds.has(row.id)),
        option: tableProps.option,
        setOption: tableProps.setOption,
        reload: tableProps.reload,
    });

    const formAddTagProps = useFormAddTag({
        rowsSelected: tableProps.rows.filter((row) => tableProps.selectedRowIds.has(row.id)),
        option: tableProps.option,
        setOption: tableProps.setOption,
        reload: tableProps.reload,
    });

    const formAssignAccrualProfileProps = useFormAssignAccrualProfile({
        rowsSelected: tableProps.rows.filter((row) => tableProps.selectedRowIds.has(row.id)),
        option: tableProps.option,
        setOption: tableProps.setOption,
        reload: tableProps.reload,
    });

    const formAssignScheduleRuleProps = useFormAssignScheduleRule({
        rowsSelected: tableProps.rows.filter((row) => tableProps.selectedRowIds.has(row.id)),
        option: tableProps.option,
        setOption: tableProps.setOption,
        reload: tableProps.reload,
    });

    const formAssignPayRuleProps = useFormAssignPayRule({
        rowsSelected: tableProps.rows.filter((row) => tableProps.selectedRowIds.has(row.id)),
        option: tableProps.option,
        setOption: tableProps.setOption,
        reload: tableProps.reload,
    });

    const formAssignHiringProps = useFormAssignHiring({
        rows: tableProps.rows,
        rowId: tableProps.rowId,
        option: tableProps.option,
        setOption: tableProps.setOption,
        reload: tableProps.reload,
    });

    const formAssignPositionProps = useFormAssignPosition({
        rows: tableProps.rows,
        rowId: tableProps.rowId,
        option: tableProps.option,
        setOption: tableProps.setOption,
        reload: tableProps.reload,
    });

    return (
        <>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex',
                }}
                className="grid gap-5"
            >
                <Breadcrumbs queryKeys={['module', 'view']} className="w-full" />

                {!tableProps.canViewTable && <EmptyState variant="no-permission" context="page" permissions={tableProps.requiredPermissions.map((permission) => permission.permission)} />}
                {formAddProps.canAddEmployee && (
                    <Box
                        component="div"
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            width: '100%',
                            '& > button': { width: { xs: '100%', sm: 'auto' } },
                        }}
                    >
                        <RBButton
                            id="menu-agregar-employee"
                            variant="primary"
                            size="s"
                            rightIcon={<Icon baseClassName="material-symbols-rounded">add</Icon>}
                            onClick={() => {
                                //tableProps.setOption("add_employee");
                                formAddProps.setOpenForm(true);
                            }}
                        >
                            {t('menu.add_employee')}
                        </RBButton>
                    </Box>
                )}

                {tableProps.canViewTable && <Table t={t} {...tableProps} rowSelected={tableProps.rowSelected} setRowSelected={tableProps.setRowSelected} />}

                <AddEmployeeDialog formProps={formAddProps} />

                {formUpdateProps.openForm && <UpdateEmployeeDialog formProps={formUpdateProps} />}

                {formAddTagProps.openForm && <AddTag formProps={formAddTagProps} />}

                {formAssignAccrualProfileProps.openForm && <AssignAccrualProfileDialog formProps={formAssignAccrualProfileProps} />}

                {formAssignScheduleRuleProps.openForm && <AssignScheduleRule formProps={formAssignScheduleRuleProps} />}

                {formAssignPayRuleProps.openForm && <AssignPayRuleDialog formProps={formAssignPayRuleProps} />}

                {formAssignHiringProps.openForm && <AssignHiringDialog formProps={formAssignHiringProps} />}

                {formAssignPositionProps.openForm && <AssignPositionDialog formProps={formAssignPositionProps} />}

                <RbContextMenu
                    open={Boolean(tableProps.contextMenu)}
                    position={tableProps.contextMenu}
                    variant={tableProps.variant}
                    items={tableProps.items.filter((item) => item.group === tableProps.variant || item.group === 'both')}
                    onClose={() => tableProps.setContextMenu(null)}
                />

                {/* <EditDialog
        employeeId={tableProps.rowId}
        option={tableProps.option}
        setOption={tableProps.setOption}
        reload={tableProps.reload}
      /> */}

                {/* <DeactivateDialog
        employeeId={tableProps.rowId}
        option={tableProps.option}
        setOption={tableProps.setOption}
        reload={tableProps.reload}
      /> */}

                {/* <AssignContractDialog
        row={tableProps.rows.find((row) => row.id === tableProps.rowId) || null}
        option={tableProps.option}
        setOption={tableProps.setOption}
        reload={tableProps.reload}
      /> */}

                {/* <AssignPositionDialog
        employeeId={tableProps.rowId}
        option={tableProps.option}
        setOption={tableProps.setOption}
        reload={tableProps.reload}
      /> */}

                {/* <AssignTagDialog
        rowsSelected={tableProps.rows.filter((row) =>
          tableProps.selectedRowIds.has(row.id),
        )}
        option={tableProps.option}
        setOption={tableProps.setOption}
        reload={tableProps.reload}
      /> */}
            </div>
        </>
    );
};

export { SubPage };
